import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { AuthGuard } from '@/components/auth-guard';
import { LibraryPage } from '@/features/files';

const LibrarySearchSchema = z.object({
  scope: z.enum(['private', 'public-downloads', 'article-assets', 'group']).optional(),
  group: z.string().optional(),
  partition: z.enum(['private', 'public-downloads', 'article-assets']).optional(),
});

function LibraryRoute(): ReactNode {
  const search = Route.useSearch();
  return (
    <AuthGuard>
      <LibraryPage search={search} />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/library')({
  validateSearch: (search) => LibrarySearchSchema.parse(search),
  component: LibraryRoute,
});
